<template>
    <div class="fm-container">
        <Backer />
        <div>
            <div style="margin: 10px; display: inline-block;">
                WHAT ARE YOU DOING:
                 <b-form-select
                    v-model="action"
                    :options="actions" 
                    size="sm" 
                    style="width: 150px;"
                ></b-form-select>
                
            </div>

            <div style="margin: 10px; display: inline-block;" v-if="action != null">
                SELECT PULLIST
                 <b-form-select
                    v-model="pullist_name"
                    :options="pullist_names" 
                    size="sm" 
                    style="width: 150px;"
                    v-on:change="fetch_init"
                ></b-form-select>
                
            </div>
        </div>

        <b-overlay :show="items_being_loaded" rounded="sm">
            <div v-if="items.length > 0">

                <b-card no-body class="overflow-hidden" style="">
                    <b-row no-gutters>
                        <b-col md="6" style="">
                            <qrcode-stream @decode="on_decode" @init="on_init"></qrcode-stream>
                        </b-col>
                        
                        <b-col md="6" style="">
                            <b-card-text>
                                <b-table-simple hover small caption-top responsive style="font-size: 14px;">
                                    <b-thead style="background: #efefef; color: black;">
                                        <b-tr>
                                            <b-th style="border: 1px solid gray;">PRD</b-th>
                                            <b-th colspan="1" style="border: 1px solid gray;">QTY</b-th>
                                            <b-th colspan="1" style="border: 1px solid gray;">SCANNED</b-th>
                                        </b-tr>
                                    </b-thead>

                                    <b-tbody>
                                        <b-tr v-for="item in items" :style="{background: (isEqual(item) ? 'lightgreen' : 'inherit')}" v-bind:key="product_sku">
                                            <b-td style="border: 1px solid gray;">{{item.product_sku }}</b-td>
                                            <b-td :style="{border: '1px solid gray', 'text-align': 'center'}">{{item.pulled_quantity}}</b-td>

                                            <b-td :style="{border: '1px solid gray'}" >
                                                {{ 
                                                  (scanned_items[item.product_sku+'|'+item.product_id] || []).length
                                                }}
                                            </b-td>
                                        </b-tr>
                                    </b-tbody>
                                </b-table-simple>
                            </b-card-text>

                            <div style="margin: auto; text-align: center;">
                                <b-button size="sm" variant="danger" @click="doneScanning">Done Scanning</b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </div>
        </b-overlay>

    </div>
</template>

<script>
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'
    import { QrcodeStream } from 'vue-qrcode-reader'

    export default {
        name: "PickAndDrop",
        props: [],
        components: { QrcodeStream, Multiselect, Backer},
        data: function(){
            return {
                userDetails: {properties: {}},
                result: '',
                error: '',
                scanned_items: {},
                input_items: {},
                pullist_name: null,
                pullist_names: [],
                action: null,
                actions: [
                    {value: "pickup", text: "Pickup"},
                    {value: "drop", text: "Drop"}
                ],
                items: [],
                items_being_loaded: false,
            }
        },
        methods: {
            doneScanning: function(e){
                if (e){
                    e.preventDefault();
                }
                this.$emit("doneScanning", JSON.stringify(this.scanned_items));
            },
            isEqual: function(item){
                if ( (this.scanned_items[item.product_sku+'|'+item.product_id] || []).length == item.pulled_quantity) {
                    return true
                }
                else {
                    return false
                }
            },
            on_decode: function(result) {
                
                if (result){
                    let parsed = this.try_parse(result);
                    if (parsed != null){

                        let key = parsed.product_sku+"|"+parsed.product_id;
                        let value = parsed.uid;

                        //if item is not in the input set of items, dont bother.
                        if (!this.input_items[key]){
                            return
                        }
                        if (this.scanned_items[key]){
                            if (this.scanned_items[key].length < this.input_items[key]){
                                if (this.scanned_items[key].indexOf(value) < 0){
                                    this.scanned_items[key].push(value);
                                    this.scanned_items = JSON.parse(JSON.stringify(this.scanned_items))
                                }
                            }
                        }
                        else {
                            //console.log(this.scanned_items)
                            this.scanned_items[key] = [value];
                            this.scanned_items = JSON.parse(JSON.stringify(this.scanned_items))
                        }
                        //now validate that the scanned items == input items
                        //let is_complete = this.validate();
                    }
                }
            
            },
            try_parse: function(value){
                let output = {};
                try {
                    let splt = value.split("|");
                    if (splt.length > 0){
                        output = {uid: splt[0], product_sku: splt[1], product_id: parseInt(splt[2])}
                    }
                }
                catch (e) {
                    output = null
                }
                return output
            },

            async on_init (promise) {
                try {
                    await promise
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                    this.error = "ERROR: you need to grant camera access permisson"
                    } else if (error.name === 'NotFoundError') {
                        this.error = "ERROR: no camera on this device"
                    } else if (error.name === 'NotSupportedError') {
                        this.error = "ERROR: secure context required (HTTPS, localhost)"
                    } else if (error.name === 'NotReadableError') {
                        this.error = "ERROR: is the camera already in use?"
                    } else if (error.name === 'OverconstrainedError') {
                        this.error = "ERROR: installed cameras are not suitable"
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        this.error = "ERROR: Stream API is not supported in this browser"
                    }
                }
            },
            is_valid_url: function(string) {
                try {
                    new URL(string);
                } catch (_) {
                    return false;  
                }
                return true;
            },
            fetch_prereqs: function(){
                let that = this;

                let prereqs = [
                    {
                        path:  "/api/user/get_tools_packet/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.locations = response.data.result.locations.map(function(d){
                                    return {value: d.id, text: d.name}
                                });
                                that.locations.splice(0, 0, {value: null,  text: "All"});
                                
                                that.locationsdict = that.locations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                                that.sublocations = response.data.result.sublocations.map(function(d){
                                    return {value: d.id, text: d.name, location_id: d.location_id}
                                });
                                that.sublocationsdict = that.sublocations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});

                                that.locsubs = response.data.result.locsubs;

                                if (that.userDetails.userrole == "storeadmin" ||  that.userDetails.userrole == "locationuser"){
                                    let location_id = that.userDetails.properties['location_id'];
                                    that.locations =  that.locations.filter(function(d){return d.value == location_id});
                                }

                                //that.fetch_init();
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading locations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },

                    {
                        path:  "/api/inventory/get_pullists_with_pulled_items/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                console.log(response.data.result)
                                that.pullist_names = response.data.result.map(function(d){
                                    return {value: d.pullist_name, text: d.pullist_name + " ("+d.cnt+")"}
                                });
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading locations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                }
            },
            fetch_init: function(){
                let that = this;
                let path = "/api/inventory/get_tr_items_pulled/"
                let data = {pullist_name: this.pullist_name}
                if (!this.pullist_name){
                    this.$bvToast.toast(
                        "Please specify a pullist.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }
                
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.items = response.data.result
                        that.input_items = that.items.reduce((map, obj) => (map[obj.product_sku+"|"+obj.product_id] = obj.pulled_quantity, map), {});
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading pullist items.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
        },
        created: function(){
            // if (this.items){
            //     this.input_items = this.items.reduce((map, obj) => (map[obj.product_sku+"|"+obj.product_id] = obj.approved_quantity, map), {});
            // }
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                this.fetch_prereqs();

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/PickAndDrop.vue